import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCustomerAddress = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.customerAddress;

export const customerAddress = setCalculationModeCustomerAddress(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_CUSTOMER_ADDRESS',
  ''
);
